import { SET_EVALUATION_DATA, SET_MODAL_TEST_SUGGESTION_AI } from '../actionTypes';

export const setEvaluationData = (evaluation) => ({
  type: SET_EVALUATION_DATA,
  payload: { evaluation },
});

export const setModalTestSuggestionAI = (show) => ({
  type: SET_MODAL_TEST_SUGGESTION_AI,
  payload: show,
});
